import {
  select,
  put,
  fork,
  call,
  takeEvery,
  all,
  take,
} from 'redux-saga/effects';
import app from '../../app';
import {
  loadImgGroupListCompletion,
  loadKillListCompletion,
  loadLimitProductListCompletion,
  loadHomeThemeListCompletion,
  loadHomeBannerListCompletion,
  loadHomeCategoryListCompletion,
  loadHomeProductListCompletion,
  loadHomeMallCompletion,
  loadWeappHomeMallCompletion,
  loadWeappHomeThemeListCompletion,
  loadHomeBannerList,
  loadHomeThemeList,
  loadHomeCategoryList,
  loadWeappBannerList,
  loadWeappBannerListCompletion,
  loadWeappHomeThemeList,
  loadPresaleList,
  loadPresaleListCompletion,
  // loadHomeGroupList,
  loadHomeGroupListCompletion,
  loadNewUserProdcutList,
} from '../../actions';

export function* watchLoadBannerList() {
  yield takeEvery('LOAD_HOME_BANNER_LIST', function*() {
    const options = {
      url: '/api/product/banner',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadHomeBannerListCompletion(result.data, result.error));
  });
}

//小程序banner图
function* watchLoadWeappBannerList() {
  yield takeEvery('LOAD_WEAPP_BANNER_LIST', function*() {
    const options = {
      url: '/api/index/banner',
      data: { client: 2, topic: 0 },
    };
    const result = yield call(app.httpFetch, options);

    yield put(
      loadWeappBannerListCompletion(
        result.error,
        (result.data && result.data.banner) || []
      )
    );
  });
}
export function* watchLoadImgGroupList() {
  yield takeEvery('LOAD_IMGGROUP_LIST', function*() {
    const own = yield select(state => state.own.own);
    const options = {
      url: `/sfapi/imageGroup/list${own ? '?level=' + own.level : ''}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadImgGroupListCompletion(result.data, result.error));
  });
}

export function* watchLoadKillList() {
  yield takeEvery('LOAD_KILL_LIST', function*() {
    const options = {
      url: '/api/ms/topic?index=1',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadKillListCompletion(result.data, result.error));
  });
}

export function* watchLoadHomeGroupList() {
  yield takeEvery('LOAD_HOME_GROUP_LIST', function*({ willReload }) {
    const { list, query } = yield select(state => state.home.mall.group);
    let start = 0;
    if (!willReload && list) {
      start = list.length;
    }

    const options = {
      url: `/api/pt/topic?start=${start}&size=${query.size}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadHomeGroupListCompletion(
        result.error,
        (result.data && result.data.listData) || [],
        (result.data && result.data.topicVo) || {}
      )
    );
  });
}

export function* watchLoadLimitProductList() {
  yield takeEvery('LOAD_LIMIT_PRODUCT_LIST', function*() {
    const options = {
      url: '/api/xg/topic',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadLimitProductListCompletion(result.error, result.data));
  });
}

export function* watchLoadHomeThemeList() {
  yield takeEvery('LOAD_HOME_THEME_LIST', function*() {
    const own = yield select(state => state.own.own);
    const options = {
      url: `/api/theme/index?no=0&size=1000${
        own ? '&level=' + own.level : ''
      }&global=true`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadHomeThemeListCompletion(result.error, result.data));
  });
}

export function* watchLoadWeappHomeThemeList() {
  yield takeEvery('LOAD_WEAPP_HOME_THEME_LIST', function*() {
    const own = yield select(state => state.own.own);
    const options = {
      url: `/api/theme/index?no=0&size=1000${
        own ? '&level=' + own.level : ''
      }&global=false`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadWeappHomeThemeListCompletion(result.error, result.data));
  });
}

export function* watchLoadHomeCategoryList() {
  yield takeEvery('LOAD_HOME_CATEGORY_LIST', function*() {
    const options = {
      url: '/api/product/channel',
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadHomeCategoryListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export function* watchLoadHomeProductList() {
  yield takeEvery('LOAD_HOME_PRODUCT_LIST', function*({ id }) {
    if (!id) {
      return;
    }
    const options = {
      url: `/api/product/index?channelId=${id}&no=0&size=999`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadHomeProductListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

function* watchLoadHomeMall() {
  yield takeEvery('LOAD_HOME_MALL', function*({ reload }) {
    const { didLoadAt } = yield select(state => state.home.mall.loadInfo);
    if (!reload && new Date().getTime() - didLoadAt < 3 * 60 * 1000) {
      yield put(loadHomeMallCompletion(new Error('请求太频繁')));
      return;
    }

    yield put(loadHomeBannerList());
    yield put(loadPresaleList());
    yield put(loadHomeThemeList());
    yield put(loadHomeCategoryList());
    yield all([
      take('LOAD_HOME_BANNER_LIST_COMPLETION'),
      take('LOAD_PRESALE_LIST_COMPLETION'),
      take('LOAD_HOME_THEME_LIST_COMPLETION'),
      take('LOAD_HOME_CATEGORY_LIST_COMPLETION'),
    ]);
    yield put(
      loadHomeMallCompletion(undefined, undefined, new Date().getTime())
    );
  });
}

function* watchLoadWeappHomeMall() {
  yield takeEvery('LOAD_WEAPP_HOME_MALL', function*({ reload }) {
    const [didLoadAt, own] = yield select(state => [
      state.home.mall.loadInfo.didLoadAt,
      state.own.own,
    ]);
    if (!reload && new Date().getTime() - didLoadAt < 3 * 60 * 1000) {
      yield put(loadWeappHomeMallCompletion(new Error('请求太频繁')));
      return;
    }
    yield put(loadWeappBannerList());
    yield put(loadPresaleList());
    yield put(loadWeappHomeThemeList());
    yield put(loadHomeCategoryList());
    // yield put(loadHomeGroupList({}));

    let array = [
      take('LOAD_WEAPP_BANNER_LIST_COMPLETION'),
      take('LOAD_PRESALE_LIST_COMPLETION'),
      take('LOAD_WEAPP_HOME_THEME_LIST_COMPLETION'),
      take('LOAD_HOME_CATEGORY_LIST_COMPLETION'),
      // take('LOAD_HOME_GROUP_LIST_COMPLETION'),
    ];

    if (!(own && own.payOrderNum)) {
      yield put(loadNewUserProdcutList());
      array.push(take('LOAD_NEWUSER_PRODUCT_LIST_COMPLETION'));
    }

    yield all(array);
    yield put(
      loadWeappHomeMallCompletion(undefined, undefined, new Date().getTime())
    );
  });
}

function* watchLoadPresaleList() {
  yield takeEvery('LOAD_PRESALE_LIST', function*() {
    const options = {
      url: '/api/yg/topic',
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadPresaleListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export default function* mallSaga() {
  yield all([
    fork(watchLoadImgGroupList),
    fork(watchLoadKillList),
    fork(watchLoadHomeGroupList),
    fork(watchLoadLimitProductList),
    fork(watchLoadBannerList),
    fork(watchLoadHomeCategoryList),
    fork(watchLoadHomeProductList),
    fork(watchLoadHomeThemeList),
    fork(watchLoadHomeMall),
    fork(watchLoadWeappHomeMall),
    fork(watchLoadWeappBannerList),
    fork(watchLoadWeappHomeThemeList),
    fork(watchLoadPresaleList),
  ]);
}
